export interface Hint {
  glossary?: string[];
  context?: string;
}

export function serializeHint(glossary: string[], context: string): Hint | undefined {
  const trimmedContext = context.trim();
  const trimmedGlossary = Array.from(
    new Set(glossary.map((term) => term.trim()).filter((term) => term.length > 0)),
  );

  const hint: Hint = {};
  if (trimmedGlossary.length > 0) hint.glossary = trimmedGlossary;
  if (trimmedContext.length > 0) hint.context = trimmedContext;

  return Object.keys(hint).length > 0 ? hint : undefined;
}
